export const PAGINATION_SIZES = [25, 50, 75, 100];
